export const uiTokens = {
    page: {
        containerWidth: {xs: '100%', md: 'calc(100% - 48px)', lg: 'calc(100% - 64px)'},
        containerMaxWidth: {md: 1240},
        paddingX: {xs: 1.5, sm: 2, md: 3, lg: 4},
        paddingY: {xs: 2, md: 3},
        sectionGap: {xs: 3, md: 4},
    },
    surface: {
        background: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        radius: 2,
        shadow: '0 4px 16px rgba(28, 28, 28, 0.035)',
        elevatedShadow: '0 5px 18px rgba(28, 28, 28, 0.05)',
        padding: {xs: 2, md: 2.5},
    },
    control: {
        radius: 1.5,
        height: 48,
    },
} as const;
